<template>
    <i class="i-ph-caret-right mt-0.5"/>
    <targeting-router-link class="crumb" :to="isCustomer ? CUSTOMERS : SUPPLIERS">
        <i :class="isCustomer ? 'i-ph-users-three-fill' : 'i-ph-truck-fill'" class="mt-0.5"/>
        {{ isCustomer ? 'Kunder' : 'Leverandører' }}
    </targeting-router-link>
    <i class="i-ph-caret-right mt-0.5"/>
    <sub-account-link v-if="subAccount" class="crumb truncate line-clamp-1" :uuid="subAccountUuid">
        <i :class="isCustomer ? 'i-mdi-account-box' : 'i-ph-truck-fill'" class="mt-0.5"/>{{ subAccount?.name }}
    </sub-account-link>
</template>

<script setup lang="ts">
import { TargetingRouterLink } from '@tritt/multipanel'
import {findSubAccountByUuid} from '@/subaccount/subAccount.service'
import {CUSTOMERS, SUPPLIERS} from '@/subaccount/index'
import {CUSTOMER} from '@/subaccount/types/SubAccount'
import {computed} from 'vue'
import SubAccountLink from '@/subaccount/components/SubAccountLink.vue'

const props = defineProps({
    subAccountUuid: {
        type: String,
        required: true
    }
})

const subAccount = computed(() => {
    return findSubAccountByUuid(props.subAccountUuid)
})

const isCustomer = computed(() => {
    return subAccount.value && subAccount.value.relationType === CUSTOMER
})

</script>

<style scoped>

</style>